/**
 * Standard exercises keep Russian `value` (API/DB); `label` is shown in UI.
 * @param {Array<{ type?: string, standard_slug?: string, label?: string, value?: string }>} items
 * @param {(key: string, vars?: object) => string} t
 * @param {string} locale
 */
export function applyLocalizedStandardLabels(items, t, locale) {
  if (!Array.isArray(items)) return items;
  if (locale === 'ru') return items;
  return items.map((ex) => {
    if (ex.type !== 'standard' || !ex.standard_slug) return ex;
    const key = `exercise.standard.${ex.standard_slug}`;
    const translated = t(key);
    if (!translated || translated === key) return ex;
    return { ...ex, label: translated };
  });
}

/**
 * Resolve UI label for a canonical (Russian) exercise name from localized catalog.
 * @param {string} canonicalName
 * @param {Array<{ value?: string, label?: string }>} localizedCatalog
 */
export function getExerciseDisplayLabel(canonicalName, localizedCatalog) {
  const n = (canonicalName || '').trim();
  if (!n) return '';
  const hit = (localizedCatalog || []).find((e) => e?.value === n);
  return hit?.label || n;
}

/**
 * Match search term against canonical name and localized label.
 */
export function exerciseMatchesSearch(canonicalName, term, localizedCatalog) {
  const q = (term || '').trim().toLowerCase();
  if (!q) return true;
  const canonical = (canonicalName || '').trim().toLowerCase();
  const display = getExerciseDisplayLabel(canonicalName, localizedCatalog).toLowerCase();
  return canonical.includes(q) || display.includes(q);
}
